var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaxonomyStudyNotes = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#taxonomy_study_notes_svg__a)",
  stroke: "#3A434A",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.758 4.82c.03-.532.067-1.08.109-1.65a1.403 1.403 0 0 1 1.188-1.286c1.983-.3 3.621-.455 5.597-.455 1.975 0 3.613.156 5.596.455.648.098 1.14.633 1.188 1.287.297 4.017.3 6.94.006 10.943a1.401 1.401 0 0 1-1.278 1.297 70.4 70.4 0 0 1-2.184.15"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.08 4.643c-1.975 0-3.613.156-5.596.455a1.404 1.404 0 0 0-1.188 1.287c-.297 4.017-.3 6.94-.006 10.944.05.687.591 1.238 1.278 1.296 1.892.159 3.702.238 5.512.238 1.81 0 3.621-.08 5.512-.238a1.401 1.401 0 0 0 1.279-1.296c.293-4.004.291-6.927-.006-10.944a1.404 1.404 0 0 0-1.188-1.287c-1.983-.299-3.621-.455-5.597-.455Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.357 9.643h5.447M5.357 13.594h3.287",
  strokeLinecap: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "taxonomy_study_notes_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgTaxonomyStudyNotes;